import { useData } from 'contexts/data';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { StubPlacements } from 'Types/Aggregates';

import './index.scss';

export default function StubPlacement() {
  const { activeUserInputs, activeAggregate } = useData();
  const { t } = useTranslation();

  const [placement, setPlacement] = React.useState<StubPlacements>();

  React.useEffect(() => {
    // get stub placement
    let set = activeAggregate?.stub_placements_right;
    if (activeUserInputs['stub_placement.version'] === 'left') {
      set = activeAggregate?.stub_placements_left;
    }

    const p = set?.stub_placements.find(
      (x) => x.id === activeUserInputs['stub_placement.placement_id']
    );
    if (p) {
      setPlacement(p);
    }
  }, [activeUserInputs, activeAggregate]);

  return (
    <>
      <h2 className="stub-placement__header">
        {t(`resultsPage.stubPlacementPage.header`)}
      </h2>
      <div className="stub-placement">
        {placement?.detailed_drawing && (
          <img
            src={placement?.detailed_drawing}
            key={placement?.detailed_drawing}
          />
        )}
        {placement?.sku && <p>SKU: {placement?.sku}</p>}
        {placement?.id && (
          <>
            <p>
              {(activeUserInputs['stub_placement.version'] === 'left' &&
                t(`resultsPage.stubPlacementPage.descriptionLeft`)) ||
                t(`resultsPage.stubPlacementPage.descriptionRight`)}
            </p>
            <p>
              {t('productPage.placement.airOut')}:{' '}
              {t(`resultsPage.stubPlacementPage.stubPlacementLabel`)}:
              {placement?.fresh_air}
            </p>
            <p>
              {t('productPage.placement.airTo')}:{' '}
              {t(`resultsPage.stubPlacementPage.stubPlacementLabel`)}:
              {placement?.supply_air}
            </p>
            <p>
              {t('productPage.placement.airFrom')}:{' '}
              {t(`resultsPage.stubPlacementPage.stubPlacementLabel`)}:
              {placement?.discharge_air}
            </p>
            <p>
              {t('productPage.placement.return')}:{' '}
              {t(`resultsPage.stubPlacementPage.stubPlacementLabel`)}:
              {placement?.extract_air}
            </p>
          </>
        )}
      </div>
    </>
  );
}
